<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="row white-bg">
        <div class="col-md-12 col-xs-12 col-sm-12 text-center">
          <div class="row mt-2 mr-2 ml-2">
            <div class="col-md-9 col-xs-9 col-sm-9 mb-2">
              <h4 class="mt-2"><b>ทะเบียนรถ/บาร์โค้ด <i class="far fa-barcode-alt"></i></b></h4>
            </div>
            <div class="col-md-3 col-xs-3 col-sm-3 mb-2">
              <button type="button" class="btn btn-primary form-control" v-on:click="exportFromExcel()">
                ดาวน์โหลด XLSX <i class="far fa-download"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="col-md-12 col-xs-12 col-sm-12 text-center">
          <div class="panel panel-default">
            <vue-bootstrap4-table :rows="table.rows" :columns="table.columns" @refresh-data="sendAPI" :config="table.config">
              <template slot="status" slot-scope="props">
                <span v-if="props.cell_value==='active'" class="badge badge-pill badge-success">&nbsp;Active&nbsp;</span>
                <span v-else-if="props.cell_value==='quit'||props.cell_value==='inactive'" class="badge badge-pill badge-danger">&nbsp;Inactive&nbsp;</span>
                <span v-else-if="props.cell_value==='wait_ride_off'" class="badge badge-pill badge-warning">&nbsp;Wait Ride Off&nbsp;</span>
                <span v-else class="badge badge-pill badge-secondary">&nbsp;{{props.cell_value}}&nbsp;</span>
              </template>
            </vue-bootstrap4-table>
          </div>
        </div>
      </div>
    </div>
    <Loading :percent="load.percent" :active="load.active"></Loading>
  </div>
</template>
<script>
import Number from '../../utils/Number.js';
import JWT from '../../utils/JWT.js';
import XLSX from 'xlsx';
export default {
  components: {
    'VueBootstrap4Table': () => import('vue-bootstrap4-table'),
    'Loading': () => import('../../utils/Loading.vue')
  },
  data() {
    return {
      alert: {
        message: ''
      },
      load: {
        task: 0,
        count: 0,
        percent: 0,
        active: false
      },
      table: {
        rows: [],
        config: {
          per_page: 25,
          per_page_options: [25,50,75,100],
          global_search: {
            placeholder: "ค้นหา...",
          }
        },
        columns: []
      }
    }
  },
  mounted() {
    this.sendAPI();
  },
  methods: {
    resetLoading(task) {
      this.load.count = 0
      this.load.task = task
      this.load.percent = 0
      this.load.active = true
    },
    async sendAPI() {
      try {
        await this.resetLoading(1)
        const res = (await this.$http.get(process.env.VUE_APP_AUTH_URL + 'api/v1/user/wallsman/bikes')).body
        let value=null, data =[], dataSet={}, startDate=null, nowDate=null, yearReal=null;
        this.table.columns=[]
        if(res['type']!='miniuser'){
          this.table.columns.push({
            label: "รหัสศูนย์กระจายสินค้า",
            name: "dt_code",
            sort: true,
          },{
            label: "รหัสมินิ",
            name: "mini_code",
            sort: true,
          },{
            label: "ชื่อมินิ",
            name: "mini_name",
            sort: true,
          });
        }
        this.table.columns.push({
          label: "รหัสบาร์โค้ดรถ",
          name: "barcode",
          sort: true
        }, {
          label: "ทะเบียนรถ",
          name: "plate_no",
          sort: true
        },{
          label: "วันที่เริ่มใช้งาน",
          name: "purchased_date",
          sort: true
        }, {
          label: "อายุการใช้งาน",
          name: "lifetime",
          sort: true
        }, {
          label: "สถานะ",
          name: "status",
          sort: true
        }, {
          label: "รหัสวอลล์แมน",
          name: "wm_code",
          sort: true,
          initial_sort: true,
          initial_sort_order: "desc"
        }, {
          label: "ชื่อ-นามสกุล",
          name: "full_name",
          sort: true
        },{
          label: "ยอดขายรวมทั้งหมด",
          name: "accumulated_sales",
          sort: true
        });
        for(value of res['data']){
          startDate=this.$moment(value.purchased_date);    
          nowDate=this.$moment();  
          yearReal=nowDate.diff(startDate, 'years');
          dataSet={
            barcode: value.barcode,
            wm_code: value.wm_code,
            full_name: value.full_name,
            plate_no: value.plate_no,
            purchased_date: this.$moment(value.purchased_date).format('YYYY-MM-DD'),
            lifetime: yearReal+' ปี '+Math.floor((nowDate.diff(startDate, 'years', true)-yearReal)*12)+' เดือน',
            accumulated_sales: await Number.formatMoney(await Number.toFixed(value.accumulated_sales, 2), 2, ".", ","),
            status: value.status.toLowerCase()
          };
          if(res['type']!='miniuser'){
            dataSet['dt_code']=value.dt_code
            dataSet['mini_code']=value.mini_code
            dataSet['mini_name']=value.mini_name
          }
          data.push(dataSet)
        }
        this.table.rows=data
        this.load.active = false
      } catch (error) {
        this.load.active = false
        if (error.body) {
          if (error.body.alert) {
            this.alert.message = error.body.alert
          } else {
            this.alert.message = 'ไม่สามารถเชื่อมต่อกับระบบได้ กรุณาตรวจสอบเครื่อข่าย'
          }
        } else {
          this.alert.message = 'ไม่สามารถเชื่อมต่อกับระบบได้ กรุณาตรวจสอบเครื่อข่าย'
        }
        this.$dialogs.alert(this.alert.message,{title: 'เกิดข้อผิดพลาดในการดึงข้อมูล'})
      }
    },
    async exportFromExcel() {
      if (this.table.rows.length > 0) {
        const wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, await XLSX.utils.json_to_sheet(this.table.rows), 'Bikes')
        XLSX.writeFile(wb, 'bikes' + await this.$moment().format('YYYY-MM-DD-H-mm-ss') + '.xlsx')
        this.$notify({
          title: 'Export Excel',
          text: 'Export Excel Bikes Succeed!'
        });
      }
    }
  }
}

</script>
